import { styles, variants, BadgeTheme } from '../BadgeStyles.css';
import { baseTheme } from './BadgeThemeBaseTheme.css';
import { multiVariantStyles } from './BadgeVariants.css';

/*******************
 * Component Theme
 *******************/

const BadgeRedwoodTheme: BadgeTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { BadgeRedwoodTheme };
